/**
 * Перечень действий для общих операций в СКУДе.
 */

export const ACTION_LOAD_ENTITIES_FOR_MULTI_EDIT = "LOAD_ENTITIES_FOR_MULTI_EDIT";
